export const CHAT_LISTENERS = {
  appListenerId: 'app_listener_id',
  loginListenerId: 'login_listener_id',
  chatMessageScreenId: 'chat_message_screen_id',
  chatConversationScreenId: 'chat_conversation_screen_id',
  unreadMessageListenerId: 'unread_message_listener_id',
}



// WEBPACK FOOTER //
// ./src/utils/enumsChat.ts